import { cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";
import Loading from "../Loading";

// Определяем базовые классы и варианты для кнопки
const buttonBaseClass = cva(
  [
    "inline-flex",
    "items-center",
    "border",
    "font-medium",
    "rounded-md",
    "text-sm",
    "px-4",
    "py-2",
    "justify-center",
    "gap-x-2",
  ],
  {
    variants: {
      color: {
        bluedark: "text-white bg-darkblue hover:bg-[#010b69]",
        blue: "text-white bg-blue-600 hover:bg-blue-700",
        red: "text-white bg-red-600 hover:bg-red-700",
        gray: "text-black bg-gray-200 hover:bg-gray-300",
        white: "text-darkblue bg-white hover:bg-gray-50 shadow-custom",
      },
      size: {
        small: "text-sm px-4 py-1",
        medium: "text-base lg:px-6 py-3 sm:px-4",
        large: "text-lg px-8 py-5",
      },
      disabled: {
        true: "cursor-not-allowed text-[#8899A8] bg-[#E5E7EB] hover:bg-[#E5E7EB]",
        false: "",
      },
      iconOnly: {
        true: "!hover:bg-none p-0 m-0 gap-x-0 lg:p-0 sm:p-0",
        false: "",
      },
    },
    defaultVariants: {
      color: "white",
      size: "medium",
      iconOnly: false,
    },
  }
);

// Типы для пропсов компонента кнопки
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: "bluedark" | "blue" | "red" | "gray" | "white";
  size?: "small" | "medium" | "large";
  icon?: JSX.Element; // Пропс для иконки (может быть React компонентом)
  iconStyle?: string;
  iconOnly?: boolean;
  loading?: boolean;
};

const TGButton: React.FC<ButtonProps> = ({
  children,
  color,
  size,
  disabled,
  icon,
  iconStyle,
  iconOnly,
  loading,
  ...buttonProps
}) => {
  // Слияние классов с twMerge, применяя условные стили
  const buttonClasses = twMerge(buttonBaseClass({ color, size, disabled, iconOnly }), buttonProps.className);

  return (
    <button
      {...buttonProps}
      className={buttonClasses}
      style={iconOnly ? { background: "none", border: "none", boxShadow: "none" } : {}}
      disabled={disabled}
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          {icon && <span className={twMerge(iconStyle)}>{icon}</span>}
          {!iconOnly && children && <span>{children}</span>}
        </>
      )}
    </button>
  );
};

export default TGButton;
